import { GET_FOUND, GET_FOUND_SUCCESS, HIDE_FOUND_MESSAGE, ON_ADD_FOUND, ON_ADD_FOUND_SUCCESS, ON_HIDE_FOUND_LOADER, ON_SHOW_FOUND_LOADER } from "../../constants/ActionTypes";
export const getFound = (pageIndex, searchText) => {
    return {
        type: GET_FOUND,
        payload: {
            pageIndex: pageIndex,
            searchText: searchText
        }
    };
};
export const getFoundSuccess = (data) => {
    return {
        type: GET_FOUND_SUCCESS,
        payload: data,
    };
};


  export const hideFoundMessage = () => {
    return {
      type: HIDE_FOUND_MESSAGE,
    };
  };
  export const hideFoundLoader = () => {
    return {
      type: ON_HIDE_FOUND_LOADER,
    };
  };
  
  export const showFoundMessage = (message) => {
    return {
      type: ON_SHOW_FOUND_LOADER,
      payload: message
    };
  };
  
  export const AddFound = (found) => {
    return {
      type: ON_ADD_FOUND,
      payload: found
    };
  };

  export const AddFoundSuccess = () => {
    return {
      type: ON_ADD_FOUND_SUCCESS
    };
  };